import { SeDateTimeString, SeDateTimeOptions } from './date-time-types'
import { SePointFormatter } from './point-formatter'
import { SeTimeFormatter } from './time-formatter'
import { extendClass } from './extend-class'

export class SeTime {

  constructor(
    value: SeDateTimeString,
    options: SeDateTimeOptions
  ) {
    this.initTime(value, options)
    this.initPoint(value, options)
  }

  public get value(): string {
    return this.luxon.toUTC().toISO() || undefined
  }

  public toString(): string {
    return this.value
  }

  public get time(): string {
    return this.format('time-with-zone')
  }

}

export interface SeTime extends SeTimeFormatter, SePointFormatter {}
extendClass(SeTime, SeTimeFormatter, SePointFormatter)
